import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User, UserDealer } from '../../../shared/interfaces/user.interfaces';
import { Observable } from 'rxjs';

const basePath = '/user/dealers';

@Injectable({
  providedIn: 'root'
})
export class UserDealersService {

  constructor(
    private http: HttpClient
  ) { }

  // Gets a list of dealers for the current user
  getDealers(): Observable<UserDealer[]> {
    return this.http.get<UserDealer[]>(`${basePath}`);
  }

  // Changes the dealer for the current user
  // This is used when a user switches to a different dealer
  // It returns the updated user object
  changeDealer(id: number): Observable<User> {
    return this.http.put<User>(`${basePath}/${id}`, {});
  }

}
